import { isPartner } from "utils/apiUtils";
import { LIMIT_FEATURE, showLimitFeatureDialog, limitsFeaturesAccess } from "utils/LimitsAndFeatures";
import { DialogHandler } from "cakemail-ui-components/lib/react";
import CreateExportDialog from "assets/js/components/generalDialogs/CreateExportDialog";
import React from "react";
import {
	deleteAllContacts,
	deleteSetOfContacts,
	suppressSetOfContacts,
	unsubscribeSetOfContacts,
} from "assets/js/scenes/contacts/scenes/listing/actions";
import store from "assets/js/store";
import { I18n, Translate } from "react-redux-i18n";
import PermanentDeleteDialog from "assets/js/components/PermanentDeleteDialog";
import { getAttributeValueBasedOnType, removeRegexCharsForOneValue } from "../scenes/automations/scenes/AutomationEditor/containers/Conditions/IfElse/utils/contactDetailsUtils";

export function buildContactJsonFromFilter(
	filters,
	op,
	setFunction = () => { }
) {
	const filtersArrayOfObjects = [];
	filters.forEach((filter) => {
		let filterObject = {};
		if (filter.type == "Segment") {
			filterObject = { [filter.op]: [] };
			if (!filter.selectedSegs || filter.selectedSegs.length == 0) return;
			filter.selectedSegs.forEach((seg) => {
				if (seg.json) filterObject[filter.op].push({ ...seg.json });
				else if (seg.query) {
					filterObject[filter.op].push({ query: seg.query });
				}
			});
		} else if (filter.type == "CampaignActivity") {
			if (!filter.selectedCamps || filter.selectedCamps.length == 0) return;
			if (filter.selectedLinks?.length > 0) {
				filterObject = { [filter.linksOp]: [] };
				filter.selectedLinks
					.map((l) => l.value.toString())
					.forEach((link) => {
						filterObject[filter.linksOp].push({
							[filter.value]: { link: link },
						});
					});
			} else {
				filterObject = { [filter.op]: [] };
				filter.selectedCamps
					.map((c) => c.toString())
					.forEach((camp) => {
						filterObject[filter.op].push({
							[filter.value]: { mailing: camp },
						});
					});
			}
		} else if (filter.type == "ContactDetails") {
			if (filter.value == "info") {
				if (!filter.selectedAttributes || filter.selectedAttributes.length == 0)
					return;
				if (
					!filter.selectedAttributesValues ||
					filter.selectedAttributesValues.length == 0
				)
					return;
				filterObject = { [filter.op]: [] };
				filter.selectedAttributesValues.forEach((attrValue) => {
					let attrJsonValue = attrValue;
					let attrOp = filter.selectedAttributesValuesOp
						? filter.selectedAttributesValuesOp
						: "eq";
					if (attrOp == "&like") {
						attrOp = "like";
						attrJsonValue = `*${attrJsonValue}*`;
					}
					if (attrOp == "&unlike") {
						attrOp = "unlike";
						attrJsonValue = `*${attrJsonValue}*`;
					}

					if (attrOp == "&start") {
						attrOp = "like";
						attrJsonValue = `${attrJsonValue}*`;
					}
					if (attrOp == "&end") {
						attrOp = "like";
						attrJsonValue = `*${attrJsonValue}`;
					}
					if (filter.selectedAttributes[0].name) {
						filterObject[filter.op].push({
							[attrOp]: {
								[filter.selectedAttributes[0].name == "subscribed_on"
									? "registered"
									: filter.selectedAttributes[0].name]: attrJsonValue,
							},
						});
					}
					else {
						filterObject[filter.op].push({
							[attrOp]: {
								[filter.selectedAttributes[0].name]: attrJsonValue,
							},
						});
					}
				});

			}
			else if (filter.selectedTags.length) {
				const tagged = filter.value == "hasTag" ? ("tagged") : ("nottagged");
				filterObject = {
					[filter.op]: [
					],
				};
				filter.selectedTags.forEach(tag => {
					const tagObject = { [tagged]: { tags: tag } };
					filterObject[filter.op].push(tagObject);
				});
			}
		} else if (filter.type === "ContactStatus" && filter.contactStatus?.value === "hard_bounce") {
			const operator = filter.contactStatus?.op
				? filter.contactStatus.op
				: "eq";
			let firstLogic = "or";
			let secondLogic = "and";
			if (operator == "ne") {
				secondLogic = "or";
				firstLogic = "and";
			}
			filterObject = {
				[firstLogic]: [

					{
						[secondLogic]: [
							{
								[operator]: { status: "active" },
							},
							{
								[operator]: { "bounce_type": "bounce_hb" },
							},
						],
					},
					{
						[operator]: { "bounce_count": "4" },
					},
				],
			};
		}
		else if (filter.type === "ContactStatus" && filter.contactStatus?.value === "soft_bounce") {
			const operator = filter.contactStatus?.op
				? filter.contactStatus.op
				: "eq";
			let firstLogic = "and";
			let bounceOperator = "ne";
			if (operator == "ne") {
				firstLogic = "or";
				bounceOperator = "eq";
			}
			filterObject = {
				[firstLogic]: [
					{
						[operator]: { status: "active" },
					},
					{
						[bounceOperator]: { "bounce_type": "bounce_hb" },
					},
					{
						[bounceOperator]: { "bounce_type": "none" },
					},
					{
						[bounceOperator]: { "bounce_count": "4" },
					}
				]
			};
		}
		else if (filter.type === "ContactStatus") {
			const operator = filter.contactStatus?.op
				? filter.contactStatus.op
				: "eq";
			let firstLogic = "and";
			if (operator == "ne") {
				firstLogic = "or";
			}
			filterObject = {
				[firstLogic]: [
					{
						[operator]: { status: filter.contactStatus?.value },
					},
					{
						[operator]: { "bounce_type": "none" }
					},
				],
			};

		}
		else if (filter.type === "BounceType") {
			const operator = filter.contactStatus?.op
				? filter.contactStatus.op
				: "eq";
			let andOR = "and";
			if (operator == "ne") {
				andOR = "or";
			}
			filterObject = {
				[andOR]: [
					{
						[operator]: { "bounce_type": filter.contactStatus?.value }
					}
				],
			};
		}
		else if (
			filter.type === "ContactInterests" &&
			filter.contactInterests &&
			filter.contactInterests?.values?.length > 0
		) {
			const interestsFilterObj = filter.contactInterests;
			filterObject = {
				[interestsFilterObj.condition]: interestsFilterObj.values.map(
					(interest) => {
						return {
							[interestsFilterObj.op]: { interest: interest.name },
						};
					}
				),
			};
		}

		filtersArrayOfObjects.push(filterObject);
	});
	let json = {};
	json = { [op]: filtersArrayOfObjects };
	setFunction(json);
}

export function buildConditionsFromJsonFilterString(filter) {
	// google cloud workflow  cannot have an object with an empty array,so we inserted the default filter.
	if (JSON.stringify(filter) === "{\"and\":[{\"or\":[{\"eq\":{\"status\":\"active\"}}]}]}") {
		filter = { and: [] };
	}
	const jsonObject = filter;
	const operator = Object.keys(jsonObject)[0]; // Gets the first key
	const actualConditions = jsonObject[operator];

	let allConditions = [];
	for (let condition of actualConditions) {
		let empty_condition = {
			type: "",
			value: "",
			op: "",
			selectedCamps: [],
			selectedSegs: [],
			selectedLinks: [],
			linksOp: "",
			contactInterests: {},
			selectedAttributes: [],
			selectedAttributesValues: [],
			selectedAttributesValuesOp: "eq",
			campaignsOption: "specific",
			selectedTags: [],
			attributeFromTriggerEventData: "",
			id: Math.random()
		};

		if (Object.keys(condition).length === 0) {
			return { operator: operator, conditions: allConditions };
		}
		let key = Object.keys(condition)[0]; // Extract the first (and only) key
		empty_condition.op = key;
		empty_condition.linksOp = key;

		const filterParams = getTypeOfFilter(condition[key][0]);
		empty_condition.type = filterParams.type;
		if (filterParams.valueArray == "contactInterests") {
			empty_condition.contactInterests =
			{
				condition: "or",
				op: filterParams.op,
				values: []
			};
		}
		for (let p of condition[key]) {
			let [[newKey, value]] = Object.entries(p);
			let [[attributeKey, attributeValue]] = Object.entries(value);
			empty_condition.value = filterParams?.value || newKey;
			empty_condition.selectedAttributesValuesOp = filterParams?.selectedAttributesValuesOp || "eq";
			if (filterParams.valueArray == "contactInterests") {
				empty_condition.contactInterests.values.push(
					{ name: removeRegexCharsForOneValue(attributeValue), alias: null, usage: null });
			}
			else {
				empty_condition[filterParams.valueArray].push(removeRegexCharsForOneValue(attributeValue));
				if (filterParams?.attributeArray && empty_condition[filterParams.attributeArray]?.length == 0) {
					empty_condition[filterParams.attributeArray].push({ name: attributeKey, type: getAttributeValueBasedOnType(attributeValue) });
				}
			}
		}
		allConditions.push(empty_condition);
	}

	return { operator: operator, conditions: allConditions };
}

export function getProperOperator(condition) {
	const type = Object.keys(condition)[0];
	const attributeName = Object.keys(condition[type])[0];
	const attributeValue = condition[type][attributeName];
	if (type == "unlike" && attributeValue.startsWith("*") && attributeValue.endsWith("*")) {
		return '&unlike';
	}
	if (type == "like" && attributeValue.startsWith("*") && attributeValue.endsWith("*")) {
		return "&like";
	}
	if (type == "like" && attributeValue.endsWith("*")) {
		return '&start';
	}
	if (type == "like" && attributeValue.startsWith("*")) {
		return '&end';
	}
	return '&like';
}

export function getTypeOfFilter(condition) {
	const type = Object.keys(condition)[0];
	switch (type) {
		case "clicked":
		case "notclicked":
		case "open":
		case "notopen":
		case "sent":
		case "notsent":
			return {
				type: "CampaignActivity",
				valueArray: "selectedCamps"
			};
		case "notinterested":
			return {
				type: "ContactInterests",
				valueArray: "contactInterests",
				value: "interests",
				op: type
			};
		case "interested":
			return {
				type: "ContactInterests",
				valueArray: "contactInterests",
				value: "interests",
				op: type
			};
		case "tagged":
			return {
				type: "ContactDetails",
				valueArray: "selectedTags",
				value: "hasTag"
			};
		case "nottagged":
			return {
				type: "ContactDetails",
				valueArray: "selectedTags",
				value: "noTag"
			};
		case "eq":
			return {
				type: "ContactDetails",
				valueArray: "selectedAttributesValues",
				attributeArray: "selectedAttributes",
				value: "info",
				selectedAttributesValuesOp: "eq",
			};
		case "ne":
			return {
				type: "ContactDetails",
				valueArray: "selectedAttributesValues",
				attributeArray: "selectedAttributes",
				value: "info",
				selectedAttributesValuesOp: "ne",
			};
		case "lt":
			return {
				type: "ContactDetails",
				valueArray: "selectedAttributesValues",
				attributeArray: "selectedAttributes",
				value: "info",
				selectedAttributesValuesOp: "lt",
			};
		case "gt":
			return {
				type: "ContactDetails",
				valueArray: "selectedAttributesValues",
				attributeArray: "selectedAttributes",
				value: "info",
				selectedAttributesValuesOp: "gt",
			};
		case "ge":
			return {
				type: "ContactDetails",
				valueArray: "selectedAttributesValues",
				attributeArray: "selectedAttributes",
				value: "info",
				selectedAttributesValuesOp: "ge",
			};
		case "le":
			return {
				type: "ContactDetails",
				valueArray: "selectedAttributesValues",
				attributeArray: "selectedAttributes",
				value: "info",
				selectedAttributesValuesOp: "le",
			};
		case "more_than_time_ago":
			return {
				type: "ContactDetails",
				valueArray: "selectedAttributesValues",
				attributeArray: "selectedAttributes",
				value: "info",
				selectedAttributesValuesOp: "more_than_time_ago",
			};
		case "more_than_time_away":
			return {
				type: "ContactDetails",
				valueArray: "selectedAttributesValues",
				attributeArray: "selectedAttributes",
				value: "info",
				selectedAttributesValuesOp: "more_than_time_away",
			};
		case "less_than_time_away":
			return {
				type: "ContactDetails",
				valueArray: "selectedAttributesValues",
				attributeArray: "selectedAttributes",
				value: "info",
				selectedAttributesValuesOp: "less_than_time_away",
			};
		case "less_than_time_ago":
			return {
				type: "ContactDetails",
				valueArray: "selectedAttributesValues",
				attributeArray: "selectedAttributes",
				value: "info",
				selectedAttributesValuesOp: "less_than_time_ago",
			};
		case "like":
			return {
				type: "ContactDetails",
				valueArray: "selectedAttributesValues",
				attributeArray: "selectedAttributes",
				value: "info",
				selectedAttributesValuesOp: getProperOperator(condition),
			};
		case "unlike":
			return {
				type: "ContactDetails",
				valueArray: "selectedAttributesValues",
				attributeArray: "selectedAttributes",
				value: "info",
				selectedAttributesValuesOp: getProperOperator(condition),
			};
	}

}

export function buildContactJsonFromFilterForAutomation(
	filters,
	op
) {
	const filtersArrayOfObjects = [];
	filters.forEach((filter) => {
		let filterObject = {};
		if (filter.type == "Segment") {
			filterObject = { [filter.op]: [] };
			if (!filter.selectedSegs || filter.selectedSegs.length == 0) return;
			filter.selectedSegs.forEach((seg) => {
				if (seg.json) filterObject[filter.op].push({ ...seg.json });
				else if (seg.query) {
					filterObject[filter.op].push({ query: seg.query });
				}
			});
		} else if (filter.type == "CampaignActivity") {
			if (!filter.selectedCamps || filter.selectedCamps.length == 0) return;
			if (filter.selectedLinks?.length > 0) {
				filterObject = { [filter.linksOp]: [] };
				filter.selectedLinks
					.map((l) => l.value.toString())
					.forEach((link) => {
						filterObject[filter.linksOp].push({
							[filter.value]: { link: link },
						});
					});
			} else {
				filterObject = { [filter.op]: [] };
				filter.selectedCamps
					.map((c) => c.toString())
					.forEach((camp) => {
						filterObject[filter.op].push({
							[filter.value]: { mailing: camp },
						});
					});
			}
		} else if (filter.type == "ContactDetails") {
			if (filter.value == "info") {
				if (!filter.selectedAttributes || filter.selectedAttributes.length == 0)
					return;
				if (
					!filter.selectedAttributesValues ||
					filter.selectedAttributesValues.length == 0
				)
					return;
				filterObject = { [filter.op]: [] };
				filter.selectedAttributesValues.forEach((attrValue) => {
					let attrJsonValue = attrValue;
					let attrOp = filter.selectedAttributesValuesOp
						? filter.selectedAttributesValuesOp
						: "eq";
					if (attrOp == "&like") {
						attrOp = "like";
						attrJsonValue = `*${attrJsonValue}*`;
					}
					if (attrOp == "&unlike") {
						attrOp = "unlike";
						attrJsonValue = `*${attrJsonValue}*`;
					}

					if (attrOp == "&start") {
						attrOp = "like";
						attrJsonValue = `${attrJsonValue}*`;
					}
					if (attrOp == "&end") {
						attrOp = "like";
						attrJsonValue = `*${attrJsonValue}`;
					}
					if (filter.selectedAttributes[0].name) {
						filterObject[filter.op].push({
							[attrOp]: {
								[filter.selectedAttributes[0].name == "subscribed_on"
									? "registered"
									: filter.selectedAttributes[0].name]: attrJsonValue,
							},
						});
					}
					else {
						filterObject[filter.op].push({
							[attrOp]: {
								[filter.selectedAttributes[0].name]: attrJsonValue,
							},
						});
					}
				});

			}
			else if (filter.selectedTags.length) {
				const tagged = filter.value == "hasTag" ? ("tagged") : ("nottagged");
				filterObject = {
					[filter.op]: [
					],
				};
				filter.selectedTags.forEach(tag => {
					const tagObject = { [tagged]: { tags: tag } };
					filterObject[filter.op].push(tagObject);
				});
			}
		} else if (filter.type === "ContactStatus" && filter.contactStatus?.value === "hard_bounce") {
			const operator = filter.contactStatus?.op
				? filter.contactStatus.op
				: "eq";
			let firstLogic = "or";
			let secondLogic = "and";
			if (operator == "ne") {
				secondLogic = "or";
				firstLogic = "and";
			}
			filterObject = {
				[firstLogic]: [

					{
						[secondLogic]: [
							{
								[operator]: { status: "active" },
							},
							{
								[operator]: { "bounce_type": "bounce_hb" },
							},
						],
					},
					{
						[operator]: { "bounce_count": "4" },
					},
				],
			};
		}
		else if (filter.type === "ContactStatus" && filter.contactStatus?.value === "soft_bounce") {
			const operator = filter.contactStatus?.op
				? filter.contactStatus.op
				: "eq";
			let firstLogic = "and";
			let bounceOperator = "ne";
			if (operator == "ne") {
				firstLogic = "or";
				bounceOperator = "eq";
			}
			filterObject = {
				[firstLogic]: [
					{
						[operator]: { status: "active" },
					},
					{
						[bounceOperator]: { "bounce_type": "bounce_hb" },
					},
					{
						[bounceOperator]: { "bounce_type": "none" },
					},
					{
						[bounceOperator]: { "bounce_count": "4" },
					}
				]
			};
		}
		else if (filter.type === "ContactStatus") {
			const operator = filter.contactStatus?.op
				? filter.contactStatus.op
				: "eq";
			let firstLogic = "and";
			if (operator == "ne") {
				firstLogic = "or";
			}
			filterObject = {
				[firstLogic]: [
					{
						[operator]: { status: filter.contactStatus?.value },
					},
					{
						[operator]: { "bounce_type": "none" }
					},
				],
			};

		}
		else if (filter.type === "BounceType") {
			const operator = filter.contactStatus?.op
				? filter.contactStatus.op
				: "eq";
			let andOR = "and";
			if (operator == "ne") {
				andOR = "or";
			}
			filterObject = {
				[andOR]: [
					{
						[operator]: { "bounce_type": filter.contactStatus?.value }
					}
				],
			};
		}
		else if (
			filter.type === "ContactInterests" &&
			filter.contactInterests &&
			filter.contactInterests?.values?.length > 0
		) {
			const interestsFilterObj = filter.contactInterests;
			filterObject = {
				[interestsFilterObj.condition]: interestsFilterObj.values.map(
					(interest) => {
						return {
							[interestsFilterObj.op]: { interest: interest.name },
						};
					}
				),
			};
		}

		filtersArrayOfObjects.push(filterObject);
	});
	let json = {};
	json = { [op]: filtersArrayOfObjects };
	if (JSON.stringify(json) === "{\"and\":[]}") {
		json = { "and": [{ "or": [{ "eq": { "status": "active" } }] }] };
	}
	return json;
}

export function buildJson(query, jsonQuery, segment, selectAllResourcePages) {
	let search = query;
	let extraJson = null;
	let json = {};

	if (jsonQuery) {
		json = jsonQuery;
	}

	if (search) {
		const emailSearch = search.split("==");
		extraJson = {
			like: { [emailSearch[0]]: emailSearch[1] },
		};
	}

	if (extraJson) {
		if (!json?.and) {
			json.and = [];
		}
		json.and.push(extraJson);
	}

	if (segment) {
		const jsonToPush = segment.json ? segment.json : { query: segment.query };

		if (jsonQuery?.or) {
			json.or.push(jsonToPush);
		} else if (jsonQuery?.and) {
			json.and.push(jsonToPush);
		} else {
			if (!json?.and) {
				json.and = [];
			}
			json.and.push(jsonToPush);
		}
	}

	if (Object.keys(json).length === 0 && selectAllResourcePages) {
		json = {
			and: [{ gt: { id: 0 } }],
		};
	}

	return json;
}

export function exportContacts(
	options = {
		selectedList: {},
		selectedContacts: [],
		segment: null,
		query: null,
		jsonQuery: null,
		selectAllPagesChecked: false,
	}
) {
	if (isPartner(true, { hideDialog: true }) && !limitsFeaturesAccess(LIMIT_FEATURE.USE_EMAIL_API)) {
		return;
	}

	if (showLimitFeatureDialog(LIMIT_FEATURE.USE_CONTACT_EXPORT)) {
		return;
	}

	if (options.selectAllPagesChecked || options.selectedContacts?.length === 0) {
		options.jsonQuery = buildJson(
			options.query,
			options.jsonQuery,
			options.segment,
			options.selectAllPagesChecked
		);
	} else {
		options.jsonQuery = {
			or: [],
		};
		options.selectedContacts.forEach((c) => {
			options.jsonQuery.or.push({ eq: { id: c.id } });
		});
	}

	DialogHandler.show({
		content: (
			<CreateExportDialog
				exportType="contactsexport"
				selectedList={options.selectedList}
				selectedContacts={options.selectedContacts}
				segment={options.segment}
				query={options.query}
				jsonQuery={options.jsonQuery}
			/>
		),
		managedByContent: true,
	});
}

export function unSubscribeContactsAction(
	options = {
		listId: null,
		selectAll: false,
		selectedContacts: [],
		segment: {},
		query: null,
		currentContactsCount: 0,
		unSelectedContacts: [],
		callback: () => { },
	}
) {
	const accountId = store.getState().global.account.id;
	if (options.selectedContacts.length > 0)
		store.dispatch(
			unsubscribeSetOfContacts(
				accountId,
				options.listId,
				options.selectedContacts.map((contact) => {
					if (contact.status != "unsubscribed") return contact.id;
				}),
				options.callback,
				options.callback
			)
		);
}

export function suppressContactAction(
	options = {
		listId: null,
		selectedContacts: [],
		selectAll: false,
		unSelectedContacts: [],
		segment: null,
		query: null,
		currentContactsCount: 0,
		callback: () => { },
	}
) {
	const accountId = store.getState().global.account.id;
	if (options.selectedContacts.length > 0)
		store.dispatch(
			suppressSetOfContacts(
				accountId,
				options.selectedContacts.map((contact) => contact.email),
				options.callback,
				options.callback
			)
		);
}

export function deleteContactsAction(
	options = {
		listId: null,
		selectAll: false,
		currentContactsCount: 0,
		query: null,
		segment: null,
		unSelectedContacts: [],
		selectedContacts: [],
		callback: () => { },
	}
) {
	const accountId = store.getState().global.account.id;

	let countText = options.selectAll
		? 0
		: options.selectedContacts.length;

	countText += ` ${I18n.t("app-contact-all-TXT-contact_selected", {
		amount: countText > 1 ? "s" : "",
	})}`;

	PermanentDeleteDialog(null, {
		title: I18n.t("app-contacts-delete-dialog_title"),
		desc: (

			<>
				{options.selectAll ? (
					<>
						<Translate value="app-manage-attributes-list-delete_content" />
					</>
				) : (
					<>
						{I18n.t("app-contacts-delete-dialog_content")} <b>'{countText}'</b>
					</>
				)}
			</>
		),
		primaryBtnClick: (text, valid, btnRef, resetState) => {
			btnRef.current.startAnimation();
			!options.selectAll
				? store.dispatch(
					deleteSetOfContacts(
						accountId,
						options.listId,
						options.selectedContacts.map((contact) => contact.id),
						() => {
							options.callback();
							resetState();
						},
						() => {
							options.callback();
							resetState();
						}
					)
				)
				: store.dispatch(
					deleteAllContacts(
						accountId,
						options.segment,
						options.listId,
						options.currentContactsCount,
						options.query,
						options.unSelectedContacts,
						() => {
							options.callback();
							resetState();
						},
						() => {
							options.callback();
							resetState();
						}
					)
				);
		},
	});
}